import EstimateIntegration from 'containers/integrations/estimate-integration/EstimateIntegration';
import { FC } from 'react';

const EstimateIntegrationPage: FC = () => {
  return <EstimateIntegration />;
};

export default EstimateIntegrationPage;
